import React from 'react'

const MainWrapper = () => {
    return (
        <div className='pt-16'>
            <img className='w-full' src="https://hatchout.co.jp/s/wp-content/themes/understrap-child/custom-lp//top-main.png" width={1100} height={1100} alt='メイン画像' />
        </div>
    )
}

export default MainWrapper